export default __webpack_public_path__ + "static/media/Izzy 9781843620211.b9ac09d6.jpg";